import React, { Component } from "react";
import { List } from "semantic-ui-react";
import { connect } from "react-redux";
import dateFormater from "../../../utils/dateFormater";
import { selectedPatient } from "../../../actions/auth";

export class LastResultItem extends Component {
  render() {
    return (
      <List.Item
        as="a"
        className="listItemPadding"
        onClick={() => {
          this.props.selectedPatient({
            patient_id: this.props.patient.cedula,
            fullname: this.props.patient.paciente,
          });
          this.props.showPatientOrderResults({
            patient_id: this.props.patient.cedula,
            orderNumber: this.props.patient.orden,
            fullname: this.props.patient.paciente,
          });
        }}
      >
        <List.Content>
          <List.Header>{this.props.patient.paciente}</List.Header>
          <List.Content>
            Identificación: {this.props.patient.cedula}
          </List.Content>
          <List.Content>
            Orden: {this.props.patient.orden} | Fecha:{" "}
            {dateFormater(this.props.patient.fecha_proceso)}
          </List.Content>
        </List.Content>
      </List.Item>
    );
  }
}

export default connect(null, { selectedPatient })(LastResultItem);
